export * from './src/material-view.component';
